import React from 'react';
import { Edit2, Plus, X } from 'lucide-react';
import '../styles/ItemForm.css';

const ItemForm = ({ formData, setFormData, handleSubmit, editingId, cancelEdit }) => {
  return (
    <div className="form-container">
      <h2 className="form-title">
        {editingId ? <Edit2 size={28} color="#667eea" /> : <Plus size={28} color="#667eea" />}
        {editingId ? 'Update Item' : 'Add New Item'}
      </h2>

      <form onSubmit={handleSubmit}>
        <div className="form-grid">
          {/* ID Input */}
          <div className="form-field">
            <label className="form-label">ID *</label>
            <input
              type="text"
              value={formData.id}
              onChange={(e) => setFormData({ ...formData, id: e.target.value })}
              disabled={!!editingId}
              placeholder="e.g., 123"
              className={`form-input ${editingId ? 'disabled' : ''}`}
            />
          </div>

          {/* Name Input */}
          <div className="form-field">
            <label className="form-label">Grocery Name *</label>
            <input
              type="text"
              value={formData.name}
              onChange={(e) => setFormData({ ...formData, name: e.target.value })}
              placeholder="e.g., Organic Apples"
              className="form-input"
            />
          </div>

          {/* Quantity Input */}
          <div className="form-field">
            <label className="form-label">Quantity *</label>
            <input
              type="text"
              value={formData.quantity}
              onChange={(e) => setFormData({ ...formData, quantity: e.target.value })}
              placeholder="e.g., 5"
              className="form-input"
            />
          </div>

          {/* Price Input */}
          <div className="form-field">
            <label className="form-label">Price (₹) *</label>
            <input
              type="text"
              value={formData.price}
              onChange={(e) => setFormData({ ...formData, price: e.target.value })}
              placeholder="e.g., 100"
              className="form-input"
            />
          </div>

          {/* Image URL Input */}
          <div className="form-field">
            <label className="form-label">Image URL *</label>
            <input
              type="text"
              value={formData.image}
              onChange={(e) => setFormData({ ...formData, image: e.target.value })}
              placeholder="https://example.com/image.jpg"
              className="form-input"
            />
          </div>

          {/* Category Dropdown */}
          <div className="form-field">
            <label className="form-label">Category *</label>
            <select
              value={formData.category}
              onChange={(e) => setFormData({ ...formData, category: e.target.value })}
              className="form-select"
            >
              <option value="perishable">Perishable</option>
              <option value="non-perishable">Non-Perishable</option>
            </select>
          </div>
        </div>

        {/* Form Buttons */}
        <div className="form-buttons">
          {editingId && (
            <button
              type="button"
              onClick={cancelEdit}
              className="btn btn-cancel"
            >
              <X size={20} />
              Cancel
            </button>
          )}
          <button
            type="submit"
            onClick={(e) => {
              console.log('Button clicked');
              handleSubmit(e);
            }}
            className="btn btn-submit"
          >
            {editingId ? <><Edit2 size={20} /> Update Item</> : <><Plus size={20} /> Add Item</>}
          </button>
        </div>
      </form>
    </div>
  );
};

export default ItemForm;